module.exports = __webpack_public_path__ + "img/ic_sha_jun.1035abad.png";